import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import styles from './Toggle.css';

const Toggle = ({ data, selected, toggle }) => (
    <div className="button-wrapper">
        {data.map((ele) => (
            <button
                key={ele.label}
                className={cn('toggle-button', {
                    'active-btn': selected === ele.val,
                    disabled: ele.disabled
                })}
                // if you click on one that is selected noop
                onClick={() => ele.val === selected || toggle(ele.val)}
                disabled={ele.disabled}
                type="button"
            >
                {ele.label}
            </button>
        ))}
        <style jsx>{styles}</style>
    </div>
);

Toggle.defaultProps = {
    data: [],
    toggle: () => {},
    selected: 'month'
};

Toggle.propTypes = {
    /**
     * Data elements to represent in the legend
     */
    data: PropTypes.instanceOf(Array),

    selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /**
     * change event callback
     */
    toggle: PropTypes.func
};

export default Toggle;
